import StepLogo from "assets/STEPLogo.png";
import TAFLogo from "assets/taf.png";
import VoltaLogo from "assets/Volta-Research-Orange-01.png";

import "./style.scss";

const HomePageFooter = () => {
    return (
        <footer className="footer-container">
            <div className="footer-text-wrapper">
                <p>
                    © Copyright 2026 Toronto and Region Conservation Authority (TRCA) | All Rights Reserved
                    <br /> Version: 2.0
                </p>
            </div>
            <div className="footer-image-wrapper">
                <a href="https://www.sustainabletechnologies.ca" target="_blank" rel="noopener noreferrer">
                    <img src={StepLogo} alt="STEP Logo" />
                </a>
            </div>
            <div className="footer-text-wrapper">
                <p>Financial support provided by:</p>
            </div>
            <div className="footer-image-wrapper-2">
                <a href="https://taf.ca" target="_blank" rel="noopener noreferrer">
                    <img src={TAFLogo} alt="TAF Logo" />
                </a>
            </div>
            <div className="footer-text-wrapper">
                <p>Created in collaboration with:</p>
            </div>
            <div className="footer-image-wrapper-2">
                <a href="https://voltaresearch.org" target="_blank" rel="noopener noreferrer">
                    <img src={VoltaLogo} alt="Volta Research Logo" />
                </a>
            </div>
        </footer>
    );
};

export default HomePageFooter;
